const setCookie = (cname, cvalue, exdays) => {
    window.dataLayer.push({ occ: cvalue, event: 'onconsent' });
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

const getCookie = (cname) => {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

const deleteCookie = (cname) => {
    if (getCookie(cname) !== '') {
        document.cookie = cname + '=' + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }
}

const debounce = (cb, delay = 500) => {
    let timeout;

    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => cb(...args), delay);
    };
};

function toggleSliderOverlay() {
    const $documentElement = document.documentElement;
    const $sliderOverlayElement = document.getElementById('slider-overlay');
    $sliderOverlayElement.classList.toggle('is-active');
}

const clickOutside = {
    beforeMount: (el, binding) => {
        el.clickOutsideEvent = event => {
            const datepicker = document.querySelector('.datepicker');
            if (!(el === event.target || el.contains(event.target)) && !(datepicker && datepicker.contains(event.target))) {
                binding.value();
            }
        };
        document.addEventListener('click', el.clickOutsideEvent);
    },
    unmounted: el => {
        document.removeEventListener('click', el.clickOutsideEvent);
    },
};

export { setCookie, getCookie, deleteCookie, debounce, toggleSliderOverlay, clickOutside };
